import { emersonRoutes } from "@clinic/emerson/data/emersonRoutes";
import { useNavigate } from "@shared/react-router-dom/useNavigate/useNavigate";

import { useProductByIdLazyQuery, type ProductData } from "./useProductById.query";

const useGoToProductDetails = () => {
  const navigate = useNavigate();
  const [findProduct] = useProductByIdLazyQuery({
    onCompleted: data => completeNavigation(data),
  });

  const completeNavigation = (data: ProductData) => {
    const { slug, availableOrMasterVariant, brand } = data?.viewer?.product || {};
    const { name: brandName } = brand || {};
    const { emersonVariantId } = availableOrMasterVariant || {};

    return navigate(
      emersonRoutes.getPDP(brandName, slug, data.viewer.product.id, emersonVariantId)
    );
  };

  const navigateToPDPForProduct = (productId: string) => {
    findProduct({ variables: { productId } });
  };

  return navigateToPDPForProduct;
};

export { useGoToProductDetails };
